import React from 'react'

export default function ReceivablesFooterStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* Modify Parent Style Content Inner */
        .content-footer-container {
          display: flex;
          font-size: 1rem;
          padding: 5px;
          justify-content: flex-end;
        }
      `}
      </style>
    </React.Fragment>
  )
}
